<template>
  <div>
    <v-row no-gutters>
      <span class="checkout-h4 accent--text">{{
        $t("finished.eventOrganizedBy")
      }}</span>
    </v-row>
    <v-row class="py-1" no-gutters>
      <span class="checkout-h4 accent--text" style="font-weight: bold">{{
        finalDetails?.orderData ? finalDetails?.orderData?.nome_organizador : ""
      }}</span>
    </v-row>
    <v-row no-gutters>
      <span class="checkout-h4 grey--text">{{
        finalDetails?.orderData?.org_cnpj
          ? `CNPJ: ${finalDetails?.orderData?.org_cnpj}`
          : `CPF: ${finalDetails?.orderData?.org_cpf}`
      }}</span>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["finalDetails"]),
  },
};
</script>
